import Alert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'

export interface IAlert {
  open: boolean
  type: 'success' | 'warning' | 'error' | 'info'
  message: string
  detailedMessages?: string[]
}

interface IAlertSnackbarProps extends IAlert {
  onClose: () => void
}

const AlertSnackbar = (props: IAlertSnackbarProps) => {
  return (
    <Snackbar
      open={props.open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={5000}
      onClose={props.onClose}
      sx={{ bottom: { xs: 16 }, width: { sm: '100%' } }}
    >
      <Alert
        variant='filled'
        severity={props.type}
        onClose={props.onClose}
        sx={{ marginX: 1, width: '100%' }}
      >
        {props.message}
        {props?.detailedMessages && props?.detailedMessages?.length > 0 && (
          <>
            {props?.detailedMessages?.map((msg, idx) => (
              <p key={`message-${idx}`}>{msg}</p>
            ))}
          </>
        )}
      </Alert>
    </Snackbar>
  )
}

export default AlertSnackbar
